import { ChangeDetectorRef, Component, EventEmitter, HostListener, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSelectChange } from '@angular/material/select';
import { CategoryService } from 'src/app/services/category.service';
import { PropertyTaxService } from 'src/app/services/propertyTax.service';
import { SharedService } from 'src/app/services/sharedService';
import { AddHierarchyDialogComponent } from '../../dialogs/add-hierarchy-dialog/add-hierarchy-dialog.component';
import { BlankDialogComponent } from '../../dialogs/blank-dialog/blank-dialog.component';
import { PropertyTaxFormComponent } from '../property-tax-form/property-tax-form.component';
import { BaseComponent } from '../../base.component';
import { distinct, takeUntil } from 'rxjs/operators';
import { MapService } from '../../map/map.service';
import { UserService } from 'src/app/services/user.service';
import { ConfirmationDialogComponent } from '../../dialogs/confirmation-dialog/confirmation-dialog.component';
import { InformationDialogComponent } from '../../dialogs/information-dialog/information-dialog.component';

@Component({
  selector: 'app-filter-dropdowns',
  templateUrl: './filter-dropdowns.component.html',
  styleUrls: ['./filter-dropdowns.component.css']
})
export class FilterDropdownsComponent extends BaseComponent implements OnInit, OnDestroy, OnChanges {
  @Output() ondropdownselected = new EventEmitter<any>()
  @Output() onformsave = new EventEmitter<any>()
  @Input() propForm
  @Input() ccData
  @Input() selectedBuildingDetails
  @Input() boundaryEditor = false
  @Input() propertyTax
  @Input() boundaries
  municipality
  municipalities
  district
  districts
  ilot
  ilots
  buildingSelected
  propertyTaxFetchSubscription
  currentForm = {}
  propertyTaxAttributes
  showPopup = false;
  popupX = 6;
  popupY = 50;
  isDragging = false;
  offsetX = 0;
  offsetY = 0;
  roleList = ['PROPERTIES_LECTEUR', 'FINANCIAL_MANAGER_ADMINISTRATOR_AND_PROPERTIES_LECTEUR', 'MAYOR_TREASURER_AND_PROPERTIES_LECTEUR'];
  user
  subscriptionConfirm: any;
  constructor(public sharedService: SharedService,
    private mapService: MapService,
    private userService: UserService,
    private cdr: ChangeDetectorRef, public dialog: MatDialog, public categoryService: CategoryService, public propertyTaxService: PropertyTaxService) {
    super()
  }
  ngOnDestroy(): void {
    super.ngOnDestroy()
    this.propertyTaxFetchSubscription && this.propertyTaxFetchSubscription.unsubscribe()
  }
  ngOnChanges(changes: SimpleChanges) {
    if (changes['propertyTax']?.currentValue) {
      if (this.propertyTax) {
        this.populateDropdowns()
        this.buildingSelected = false
        this.cdr.detectChanges();
        this.propertyTaxAttributes = this.propertyTax?.attributes
        this.buildingSelected = true
        this.showFormModal()
        this.cdr.detectChanges();
      }
    }
  }
  startDrag(event: MouseEvent) {
    this.isDragging = true;
    this.offsetX = event.clientX - this.popupX;
    this.offsetY = event.clientY - this.popupY;
  }

  // Track mouse movement
  @HostListener('document:mousemove', ['$event'])
  onMouseMove(event: MouseEvent) {
    if (!this.isDragging) return;
    this.popupX = event.clientX - this.offsetX;
    this.popupY = event.clientY - this.offsetY;
  }

  // Stop dragging
  @HostListener('document:mouseup')
  onMouseUp() {
    this.isDragging = false;
  }
  async ngOnInit() {
    this.user = await this.userService.getCurrentUser().toPromise();
    this.sharedService.openPropertyTaxFormSubject$.pipe(takeUntil(this.destroy$)).subscribe(
      (stg) => {
        this.makeBuildingChanges(stg)
      }
    )
    this.sharedService.closePropertyTaxFormSubject$.pipe(takeUntil(this.destroy$)).subscribe(
      (stg) => {
        this.closeForm()
      }
    )
    this.sharedService.changeStageSubject$.pipe(takeUntil(this.destroy$)).subscribe(
      (stg) => {
        this.currentForm[stg.index] = stg.stg
      }
    )
    this.sharedService.propertyTaxSubject$
      .pipe(takeUntil(this.destroy$))
      .subscribe(pr => {
        this.addPropTax(pr.type, pr.index, pr.taxPayer, pr.declare);
      });
    this.sharedService.popupPositionSubject$.subscribe(val => {
      // this.buildingSelected = true
    })
    this.sharedService.polygonSelectedSubject$.subscribe(async val => {
      let id = JSON.parse(val.attributes)
      let layer = this.getLayer(val.layer)
      let field
      if (layer === 'municipality') {
        this.municipality = this.municipalities.find(elem => elem.id === id.id)
        field = 'MUNICIPALITY'
      } else if (layer === 'district') {
        this.district = this.districts.find(elem => elem.id === id.id)
        field = 'DISTRICT'
      }
      else if (layer === 'ilot') {
        this.ilot = this.ilots.find(elem => elem.id === id.id)
        field = 'ILOT'
      }

      this.populateFields(this.getDropdownValue(field), field)
      this.onOptionClicked(field)
      let boundary = await this.propertyTaxService.getBoundary(id.id).toPromise()
      this.ondropdownselected.emit({ field, value: boundary?.value || this.municipality, id: boundary?.id, coordinates: boundary?.coordinates })
    })
    this.sharedService.changeMunicipalityEmitter.subscribe(async val => {
      if (!this.propertyTax) {
        this.municipality = val || null;
        this.district = null;
        this.ilot = null;
        this.districts = [];
        this.ilots = [];
    
        if (this.municipality && this.municipality.id && this.municipality.id !== '-1') {
          this.districts = await this.categoryService
            .getSubList('dictionary/municipality/' + this.municipality.id + '/district')
            .toPromise();
    
            const boundary = await this.propertyTaxService.getBoundary(this.municipality.id).toPromise();

            setTimeout(() => {
              this.ondropdownselected.emit({
                field: 'MUNICIPALITY',
                value: boundary?.value || this.municipality,
                id: boundary?.id,
                coordinates: boundary?.coordinates
              });
            });
          } else {
            setTimeout(() => {
              this.ondropdownselected.emit({
                field: 'MUNICIPALITY',
                value: null,
                id: null,
                coordinates: null
              });
              this.cdr.detectChanges();
          });
        }
      }
    })
    if (this.propertyTax) {
      this.buildingSelected = false
      this.cdr.detectChanges();
      this.propertyTaxAttributes = this.propertyTax?.attributes
      this.buildingSelected = true
      this.showFormModal()
      this.cdr.detectChanges();
    }
    this.sharedService.updateAddHierarchyEmitter.subscribe(async res => {

      if (res['class'] === 'DISTRICT') {
        res['parent'] = this.municipality
      }
      if (res['class'] === 'DIVISION') {
        res['parent'] = this.district
      }
      await this.categoryService.addEntity(res).toPromise()

      if (res['class'] === 'MUNICIPALITY') {
        this.municipalities = await this.categoryService.getList('municipality').toPromise()
      }
      if (res['class'] === 'DISTRICT') {
        this.districts = await this.categoryService.getSubList('dictionary/municipality/' + this.municipality.id + '/district').toPromise()
      }
      if (res['class'] === 'DIVISION') {
        this.ilots = await this.categoryService.getSubList('dictionary/district/' + this.district.id + '/division').toPromise()
      }
    })

    this.categoryService.getList('municipality').subscribe(async mun => {
      this.municipalities = mun;
    
      const selectedMunicipalityId = localStorage.getItem('municipality');
    
      if (!this.propertyTax && selectedMunicipalityId && selectedMunicipalityId !== '-1') {
        this.municipality = this.municipalities.find(elem => elem.id === selectedMunicipalityId);
    
        if (this.municipality) {
          this.districts = await this.categoryService
            .getSubList('dictionary/municipality/' + this.municipality.id + '/district')
            .toPromise();
    
            const boundary = await this.propertyTaxService.getBoundary(this.municipality.id).toPromise();

            setTimeout(() => {
              this.ondropdownselected.emit({
                field: 'MUNICIPALITY',
                value: boundary?.value || this.municipality,
                id: boundary?.id,
                coordinates: boundary?.coordinates
              });
              this.cdr.detectChanges();
          });
        }
      }
      this.populateDropdowns();
    })
  }

  async populateDropdowns() {
    if (this.propertyTax && this.municipalities) {
      this.municipality = this.municipalities.find(elem => elem.id === this.propertyTax.municipality.id)
      this.districts = await this.categoryService.getSubList('dictionary/municipality/' + this.municipality.id + '/district').toPromise()
      this.district = this.districts.find(elem => elem.id === this.propertyTax.district.id)
      this.ilots = await this.categoryService.getSubList('dictionary/district/' + this.district.id + '/division').toPromise()
      this.ilot = this.ilots.find(elem => elem.id === this.propertyTax.ilot.id)
    }
  }

  getLayer(layer) {
    return layer.split('_')[0]
  }

  async makeBuildingChanges(stg) {
    if (this.selectedBuildingDetails) {
      let prt;
  
      if (stg === 'BUILDING') {
        prt = await this.propertyTaxService
          .getPropertyTaxesByBuildingId(this.selectedBuildingDetails.id)
          .toPromise();
      }
  
      if (stg === 'LOT') {
        prt = await this.propertyTaxService
          .getLotByLotId(this.selectedBuildingDetails.id)
          .toPromise();
      }
  
      this.buildingSelected = false;
      this.cdr.detectChanges();
  
      this.propertyTax = prt;
  
      if (stg === 'LOT') {
        this.propertyTaxAttributes = {
          ...this.propertyTax?.attributes,
          _meta: {
            taxPayer: this.propertyTax?.taxPayer
          }
        };
      }
  
      if (stg === 'BUILDING') {
        this.propertyTaxAttributes = prt.map(item => ({
          ...item.attributes,
          _meta: {
            user: item.user,
            editedBy: item.editedBy,
            editDate: item.editDate,
            id: item.id,
            buildingId: item.building?.id,
            taxPayer: item.taxPayer
          }
        }));
      }
  
      this.buildingSelected = true;
      this.showFormModal();
      this.cdr.detectChanges();
    }
  }

  async addPropTax(type, index, taxPayer = null, declareAfterSave = false) {
    switch (type) {
      case 'FEATURE':
        await this.addLot(taxPayer, declareAfterSave);
        break;
  
      case 'BUILDING':
        await this.addBuildingPropTax(index, taxPayer, declareAfterSave);
        break;
  
      default:
        break;
    }
  }
  async addLot(taxPayer = null, declareAfterSave = false) {
    let featureAttributes = this.selectedBuildingDetails.attributes
    let ilot
    let district
    let municipality
    let lotNumber = this.currentForm[0].rows.find(elem => elem['lot'])
    if (featureAttributes.ilot) {
      ilot = { name: featureAttributes.ilot.key, id: featureAttributes.ilot.attributes.id }
      district = await this.categoryService.getCategory('district', featureAttributes.ilot.attributes.parentId).toPromise()
      if (district)
        municipality = await this.categoryService.getParentByChild('municipality', district.id).toPromise()
    }
    let featureObject = { key: lotNumber?.lot, attributes: { ilot: ilot?.name }, geoJson: this.boundaries }
    if (this.selectedBuildingDetails?.id) {
      featureObject['id'] = this.selectedBuildingDetails.id
    }
    try {
      let lot = await this.mapService.upsertFeature$(featureObject, this.sharedService.getLayer('lot')).toPromise()
      if (lot)
        this.onformsave.emit({
          id: this.propertyTax?.id, municipality: municipality,
          district: district, ilot: ilot, form: this.currentForm[0], lot: {
            id: lot?.data?.id, attributes: featureObject.attributes
          },
          taxPayer: taxPayer,
          declare: declareAfterSave,
          declarationType: 'LOT'
        })
      this.buildingSelected = false
    } catch (error) {
      console.error('Error saving feature')
    }

  }
  async addBuildingPropTax(index, taxPayer = null, declareAfterSave = false) {
    let buildingAttributes = this.selectedBuildingDetails.attributes || this.propertyTax?.building.attributes || this.propertyTax[index]?.building.attributes
    let lot = buildingAttributes.lot?.key
    let lotId = buildingAttributes.lot?.id
    let ilot = buildingAttributes.ilot ? { name: buildingAttributes.ilot.key, id: buildingAttributes.ilot.attributes.id } : null
    let district = ilot ? await this.categoryService.getCategory('district', buildingAttributes.ilot.attributes.parentId).toPromise() : null
    let municipality = ilot ? await this.categoryService.getParentByChild('municipality', district.id).toPromise() : null
    let buildingObject = { attributes: { ilot: buildingAttributes?.ilot?.key, lot, lotId }, geoJson: this.boundaries }
    if (this.selectedBuildingDetails?.id) {
      buildingObject['id'] = this.selectedBuildingDetails.id
    }
    let building = await this.mapService.upsertBuilding$(buildingObject).toPromise()
    let propTaxId = this.propertyTax?.id || this.propertyTax[index]?.id
    const payload = {
      id: propTaxId,
      municipality,
      district,
      ilot,
      lot,
      form: this.currentForm[index],
      building: {
        id: building.id,
        attributes: buildingObject.attributes
      },
      taxPayer,
      declare: declareAfterSave,
      declarationType: 'BUILDING'
    };
    this.onformsave.emit(payload);
    this.buildingSelected = false
  }


  activeSelect: string | null = null;
  onSelect(event: MatSelectChange, field: string) {
    this.populateFields(event.value, field)
  }


  async populateFields(value: any, field: string) {
    if (field === 'MUNICIPALITY') {
      this.districts = await this.categoryService.getSubList('dictionary/municipality/' + value.id + '/district').toPromise()
      this.ilots = []
    }
    if (field === 'DISTRICT') {
      this.ilots = await this.categoryService.getSubList('dictionary/district/' + value.id + '/division').toPromise()
    }
    let boundary = await this.propertyTaxService.getBoundary(value.id).toPromise()
    this.ondropdownselected.emit({ field, value: boundary?.value || value, id: boundary?.id, coordinates: boundary?.coordinates })
    this.activeSelect = field;
  }

  getDropdownValue(field) {
    if (field === 'MUNICIPALITY') {
      return this.municipality
    }
    if (field === 'DISTRICT') {
      return this.district
    }
    if (field === 'ILOT') {
      return this.ilot
    }
  }

  onOptionClicked(field: string) {
    this.activeSelect = field;
  }


  showAddLevelDialog(level) {
    const dialogRef = this.dialog.open(AddHierarchyDialogComponent, {
      width: '800px', panelClass: 'custom-dialog-container',
      data: level
    });

    dialogRef.afterClosed().subscribe(result => {
    });
  }

  showFormModal() {
    const isLotForm = this.ccData.key === 'lotAttrForm';
    const isBuildingForm = this.ccData.key === 'propTaxForm';

    let actionButtons = [];

    if (!this.roleList.includes(this.user.role) && isLotForm) {
      actionButtons.push({
        name: "ACTION.SAVE",
        action: 'SAVE',
        color: 'primary',
        icon: 'save',
        disabled: true
      });

      actionButtons.push({
        label: 'ACTION.DECLARE',
        action: 'DECLARE',
        color: 'primary',
        disabled: true,
        taxPayer: null
      });

      if (this.user.role !== 'AGENT_RECENSEUR') {
        actionButtons.push({
          name: "ACTION.DELETE",
          action: 'DELETE',
          color: 'warn',
          icon: 'delete',
          disabled: !this.propertyTax?.id,
          id: this.propertyTax?.id,
          lotId: this.propertyTax?.lot?.id
        });
      }
    }

    if (!this.roleList.includes(this.user.role) && !isLotForm && !isBuildingForm) {
      actionButtons.push({
        name: "ACTION.SAVE",
        action: 'SAVE',
        color: 'primary',
        icon: 'save'
      });

      if (this.user.role !== 'AGENT_RECENSEUR') {
        actionButtons.push({
          name: "ACTION.DELETE",
          action: 'DELETE',
          color: 'warn',
          icon: 'delete',
          id: this.propertyTax?.id,
          lotId: this.propertyTax?.lot?.id
        });
      }
    }

    actionButtons.push({
      name: "ACTION.CLOSE",
      action: 'CANCEL',
      color: 'warn',
      icon: 'cancel'
    });
    let types = { lotAttrForm: 'FEATURE', propTaxForm: 'BUILDING' }
    let data = {
      type: types[this.ccData.key],
      processKey: this.ccData.key,
      processName: this.ccData.name,
      formEditorConfiguration: 'singleForm',
      ccData: this.ccData,
      formCreation: false,
      currentStage: this.propForm,
      processStageData: this.propertyTaxAttributes,
      id: this.propertyTax?.id,
      user: this.propertyTax?.user,
      editedBy: this.propertyTax?.editedBy
    }
    let buildingLot
    if (this.selectedBuildingDetails.attributes?.lot) {
      if (typeof this.selectedBuildingDetails.attributes?.lot === 'string')
        buildingLot = this.selectedBuildingDetails.attributes?.lot
      else
        buildingLot = this.selectedBuildingDetails.attributes?.lot.key
    }
    this.setupFormData(this.ccData.key, data, buildingLot)
    const dialogRef = this.dialog.open(BlankDialogComponent, {
      width: '650px', panelClass: 'no-padding-dialog',
      data: {
        component: PropertyTaxFormComponent,
        data,
        actionButtons,
        listeners: ['onActionStateChange']
      }
    });

    dialogRef.afterClosed().subscribe(result => {
    });
  }

  setupFormData(type, data, buildingLot) {
    const setOrUpdateField = (rows, fieldName, value) => {
      let field = rows.find(elem => fieldName in elem);
      if (!field) {
        rows = rows.filter(elem => !(fieldName in elem));
        rows.push({ [fieldName]: value });
      } else if (!field[fieldName]) {
        field[fieldName] = value;
      }
      return rows;
    };

    const areaValue = this.selectedBuildingDetails.area;

    if (type === 'propTaxForm') {
      data.processStageData = data.processStageData || [];
      data.processStageData.push({
        key: this.ccData.key,
        name: this.ccData.name,
        rows: [],
      });
      data.processStageData.forEach(stage => {
        stage.rows = setOrUpdateField(stage.rows, 'area', areaValue);
        stage.rows = setOrUpdateField(stage.rows, 'lot', buildingLot);
      });
      return;
    }

    if (type === 'lotAttrForm') {
      if (!data.processStageData) {
        data.processStageData = {
          key: this.ccData.key,
          rows: [],
        };
      }

      const rows = data.processStageData.rows || [];
      data.processStageData.rows = setOrUpdateField(rows, 'area', areaValue);
      data.processStageData.rows = setOrUpdateField(data.processStageData.rows, 'lot', buildingLot);
    }
  }

  async onDeleteDistrict(event: Event, district: any) {
    event.stopPropagation();
    let dist = await this.categoryService.getCategory('district', district.id).toPromise()
    if (dist && dist.division?.length > 0) {
      this.dialog.open(InformationDialogComponent, {
        width: '500px',
        data: { text: 'PROPERTY-TAX-DIALOG.DISTRICT_HAS_LOTS', error: true }
      });
    } else {
      this.dialog.open(ConfirmationDialogComponent, {
        width: '500px',
        data: { text: "DIALOG.DELETE_CURRENT_DISTRICT", emitter: null, obj: dist, action: "DELETE_DISTRICT" }
      });

      this.sharedService.deleteDistrictSubject$.pipe(takeUntil(this.destroy$)).subscribe(async (district) => {
        this.categoryService.deleteEntity('district', district).toPromise()
        this.districts = await this.categoryService.getSubList('dictionary/municipality/' + this.municipality.id + '/district').toPromise()
      });
    }
  }

  async onDeleteIlot(event: Event, ilot: any) {
    event.stopPropagation();
    this.dialog.open(ConfirmationDialogComponent, {
      width: '500px',
      data: { text: "DIALOG.DELETE_CURRENT_ILOT", emitter: null, obj: ilot, action: "DELETE_ILOT" }
    });

    this.sharedService.deleteILotSubject$.pipe(takeUntil(this.destroy$)).subscribe(async (ilot) => {
      this.categoryService.deleteEntity('division', ilot).toPromise()
      this.ilots = await this.categoryService.getSubList('dictionary/district/' + this.district.id + '/division').toPromise()
    });
  }

  closeForm() {
    this.dialog.closeAll()
  }

  canDeleteProperty() {
    if (this.user) {
      return ['ADMIN'].includes(this.user.role)
    }
    return false
  }

}
